import {connect} from 'react-redux'
import PartCategoryTreeSelectField from './partCategoryTreeSelectField'
import {getPartCategoryTreeSelectField} from 'selectors/priceLists'
import {getUser} from 'selectors/auth'
import {
  searchPartCategories,
  selectAllPriceLists,
  loadPriceLists,
  selectPriceList,
  loadPartCategories,
  selectPartCategory,
} from 'actions/partCategoryTreeSelectField'
import {loadPartCategories as loadAllPartCategories} from 'actions/priceLists'
import {getPartCategories} from 'selectors/data'

const mapStateToProps = (state) => {
  const {
    search,
    priceLists,
    priceListId,
    categories,
    category,
    categoryId,
    parentCategories,
    parentCategoryIds,
  } = getPartCategoryTreeSelectField(state)

  return {
    user: getUser(state),
    initialised: !!categories,
    partCategories: getPartCategories(state),
    search,
    priceLists,
    priceListId,
    categories,
    category,
    categoryId,
    parentCategories,
    parentCategoryIds,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadPriceLists: () => dispatch(loadPriceLists()),
    onLoadPartCategories: () => dispatch(loadPartCategories()),
    onLoadAllPartCategories: () => dispatch(loadAllPartCategories()),
    onSearch: (search) => dispatch(searchPartCategories(search)),
    onSelectAllPriceLists: () => dispatch(selectAllPriceLists()),
    onSelectPriceList: (priceListId) => dispatch(selectPriceList(priceListId)),
    onSelectCategory: (category, forwardNav) => dispatch(selectPartCategory(category, forwardNav)),
  }
}

const PartCategoryTreeSelectFieldContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PartCategoryTreeSelectField)

export default PartCategoryTreeSelectFieldContainer